import React, { useState, useEffect, useCallback } from "react";
import Loading from "./Loading";
import Animes from "./animes";
import Footer from "./footer";
import { library } from "../node_modules/@fortawesome/fontawesome-svg-core";
import { fab } from "../node_modules/@fortawesome/free-brands-svg-icons";
library.add(fab);
// ATTENTION!!!!!!!!!!
// I SWITCHED TO PERMANENT DOMAIN
function App() {
  // const [search, setSearch] = useState("");
  const url = "https://api.jikan.moe/v4/anime?q=";
  const query = "&order_by=members&sort=desc&page=";

  const [loading, setLoading] = useState(false);
  const [anime, setAnime] = useState([]);
  const [name, setName] = useState("");
  const [err, setErr] = useState(false);
  const [number, setNumber] = React.useState(0);
  const [top, setTop] = useState([]);

  const removeAnime = (id) => {
    const newAnime = anime.filter((item) => item.mal_id !== id);
    setAnime(newAnime);
  };

  const fetchAnime = async () => {
    if (name) {
      try {
        setLoading(true);
        const response = await fetch(url + name);
        const anime = await response.json();
        setLoading(false);
        setErr(false);
        setName("");
        setAnime(anime.data);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else {
      setErr(true);
    }
  };

  // Fetch Top anime for examples
  const fetchTopAnime = async () => {
    if (number > 0 && !name) {
      try {
        setLoading(true);
        const response = await fetch(url + query + number);
        console.log(response);
        const anime = await response.json();
        console.log(anime);
        setLoading(false);
        setErr(false);
        setNumber(0);
        setAnime(anime.data);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else {
      setErr(true);
    }
  };

  // Fetch by popularity
  const fetchPopular = useCallback(async () => {
    if (!name && number === 0) {
      try {
        setLoading(true);
        const response = await fetch(url + query + 1);
        const anime = await response.json();
        setLoading(false);
        setTop(anime.data);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  }, [name, number]);

  // const fetchPopular = async () => {

  // };

  useEffect(() => {
    fetchPopular();
  }, [fetchPopular]);

  if (loading) {
    return (
      <main>
        <Loading />
      </main>
    );
  }

  return (
    <div className="page">
      <main>
        <Animes
          name={name}
          setName={setName}
          fetchAnime={fetchAnime}
          anime={anime}
          removeAnime={removeAnime}
          err={err}
          number={number}
          setNumber={setNumber}
          fetchTopAnime={fetchTopAnime}
          top={top}
        />
      </main>
      <Footer />
    </div>
  );
}

export default App;
